import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ReleaseLogs/releaselogsout.html'
})

export class ReleaseLogsOutComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public applications: any[] = [];

    public customers: any[] = [];

    public users: any[] = [];
    public applicationReleaseLogs : any[] = []; 

    public lastLogDate : Date = new Date("01/01/2017");

   public filterCustomerStatus: any = "";
   public filterUserStatus: any = "";

   public filter;

    public selectedApplicationLog: any = {};

    public selectedApplication:any = {};

    public isAdd: boolean = true;
    active = true;
    public showLoader = false;
    public existsApplicationName: boolean = false;
    public isFormSubmitted: boolean = false;

    showVersionBtn: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe,private activatedRoute: ActivatedRoute,
        private _Router: Router) {
            
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filterCustomerStatus = this.constants.enumCustomerStatus["Active"];
        this.filterUserStatus = this.constants.enumUserStatus["Active"];

        this.filter = { 'ApplicationIdString': ''};

        this.activatedRoute.queryParams.subscribe(
            (param: any) => {
                if (param["appid"]) {
                    this.filter.ApplicationIdString = param["appid"];
                }
            });

        

    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
    
        if(this.filter.ApplicationIdString != null && this.filter.ApplicationIdString != ""){
            this.getApplicationLogs();
        }


    }

    ExportItems() {
        
    }

    public clearFilter() {
        
            this.filter = { 'ApplicationIdString': ''};
    }

    ngAfterViewInit() {
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });       

        $("#show-filter").click(function () {
            $(".filter-form").slideToggle();           
        }).bind(this);    

         

    }


    public getCustomers() {
        this.showLoader = true;
        this._httpService.ajaxPost('Customer/GetCustomer', { "CustomerId": 0, "CountryId": 0, "CustomerStatus": this.filterCustomerStatus }).subscribe(
            data => {
                this.customers = data["CustomerList"];
            
             this.customers.sort(function (a, b) {
                if (a.Customer_Name.toLowerCase() < b.Customer_Name.toLowerCase()) return -1;
                if (a.Customer_Name.toLowerCase() > b.Customer_Name.toLowerCase()) return 1;
                return 0;
            })

            },
            err => {
                this.showLoader = false;
            },

            () => {
                this.showLoader = false;

            }
        );
    }
    
    
    public getApplicationLogs() {
        var appId;
        appId = this.filter.ApplicationIdString;

        if(appId == "" || appId == null){
            return;
        }

        this.showLoader = true;
        this._httpService.ajaxPost('Application/GetApplicationReleaseLogs', {
            "ApplicationIdString": appId
        }).subscribe(
            data => {
                this.applicationReleaseLogs = data["ApplicationReleaseLogs"];
                this.applicationReleaseLogs.forEach(element => {
                    element.ReleaseDate = this._datepipe.transform(element.ReleaseDate, 'dd/MM/yyyy');
                });
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
            );
    }

    public viewFullLog(item: any){
        $('#btnaddEditApplicationLogForm').trigger('click');
        this.selectedApplicationLog = item;

    }


}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ReleaseLogs/releaselogsout.component.ts
 **/